import React from 'react';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { bookSingleDayMovementByOfficeId } from "../../../../store/officeUsage.duck";
import { Period } from '@features/whereabouts/models/movements.models';
import { useDispatch } from "react-redux";
import { Moment } from "moment";
import { Row } from '@shared/ui/atoms/StructuralLayout';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { useTranslation } from "react-i18next";

export function BookingPopup(props: Props) {
  const {isSelected, label, officeId, onSelect, date} = props;
  const {t} = useTranslation()
  const dispatch = useDispatch();

  const onBookDesk = (e: Event, period: Period) => {
    e.stopPropagation();
    dispatch(bookSingleDayMovementByOfficeId({
      date: date,
      officeId: officeId,
      period: period
    }));
    onSelect();
  }

  return (
    <Popup isVisible={isSelected}>
      <BodyRegular weight={400} colour={Colours.darkGrey} style={{marginBottom: 12}}>{t('company-view-page.area')} {label}</BodyRegular>
      <Row style={{marginBottom: 16}}>
        <OutlineButton text="button.book-am" style={{marginRight: 8}} click={(e: Event) => onBookDesk(e, Period.AM)} />
        <OutlineButton text="button.book-pm" style={{marginLeft: 8}} click={(e: Event) => onBookDesk(e, Period.PM)} />
      </Row>
      <PrimaryButton fullWidth={true} click={(e: Event) => onBookDesk(e, Period.AllDay)} text="button.book-all-day"/>
    </Popup>
  )
}

interface Props {
  isSelected: boolean;
  officeId: number;
  label: string;
  date: Moment;
  onSelect: (areaSpot?: any) => void;
}

const Popup = styled.div<any>`
  width: 260px;
  min-height: 120px;
  background-color: white;
  border: 1px solid ${Colours.veryLightGrey};
  box-shadow: 0 22px 24px 2px rgba(0, 87, 255, 0.15);
  border-radius: 16px;
  left: 12.5%;
  top: -25%;
  position: absolute;
  z-index: 150;
  display: ${props => props.isVisible ? 'flex' : 'none'};
  justify-content: center;
  padding: 24px;
  flex-direction: column;
`
